module.exports = __webpack_public_path__ + "img/call.31edb985.svg";